<template>
  <v-combobox
    :label="label"
    class="mb-3"
    v-model="draft"
    :hide-no-data="!search"
    :disabled="disabled"
    :search-input.sync="search"
    hide-selected
    multiple
    small-chips
    append-icon="list_alt"
    :hint="hint"
    :placeholder="placeholder"
    persistent-hint
  >
    <nx-seo-origin-chip :value="origin" v-if="!draft.length" slot="append"></nx-seo-origin-chip>
    <template slot="no-data">
      <v-list-tile>
        <span class="subheading" v-html="$t('message.seo.addKeyword')"></span>
        <v-chip label small>
          {{ search }}
        </v-chip>
      </v-list-tile>
    </template>
    <template
      slot="selection"
      slot-scope="{ item, parent, selected }"
    >
      <v-chip :selected="selected" label small>
        <span class="pr-2">
          {{ item }}
        </span>
        <v-icon small @click="parent.selectItem(item)">close</v-icon>
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
import BaseField from '@/modules/seo/components/BaseField';
import OriginChip from '@/modules/seo/components/OriginChip';

export default {
  name: 'nx-seo-array-field',
  extends: BaseField,
  components: {
    [OriginChip.name]: OriginChip,
  },
  data() {
    return {
      search: null,
    };
  },
  computed: {
    hint() {
      if (this.draft.length > 0) {
        return `Vista previa: ${this.draft.join(', ')}`;
      }
      return this.effectiveValue;
    },
    placeholder() {
      if (!this.inheritedValue) {
        return null;
      }
      return this.inheritedValue.value.join(', ');
    },
  },
};
</script>

<style lang="stylus" scoped>
.showPointer {
  cursor: pointer;
}
</style>
